import React from "react";

import { NewImg } from "./is-new-icon.styles";

import newIcon from "../../assets/newButtonRed.png";

const IsNewIcon = ({ isNew }) => (
  <div>{isNew ? <NewImg src={newIcon} alt="isNew"></NewImg> : null}</div>
);

export default IsNewIcon;
